<template>
    <v-container>

        <v-layout wrap>
            <v-flex xs12>
                <w-main-title
                        :title=" '¡Hola ' + ((currentUser && currentUser.first_name) || '') + '!' "
                        :breadcrumbs="breadcrumbs"
                ></w-main-title>
            </v-flex>
        </v-layout>

        <v-layout wrap>
          <v-flex xs12 >
            <component :is="dashboardComponentName" />
          </v-flex>
        </v-layout>

    </v-container>
</template>

<script>
    import WMainTitle from '@/components/common/WMainTitle'
    import ProviderOnBoarding from '@/components/dashboard/ProviderOnBoarding'
    import BasicProviderDashboard from '@/components/dashboard/BasicProviderDashboard'
    import SpecialistDashboard from '@/components/dashboard/SpecialistDashboard'
    import AdministrativeDashboard from '@/components/dashboard/AdministrativeDashboard'

    import {dashboardComponentName} from '@/utils/Account'
    import {mapState} from 'vuex'
    import PositiveBanner from "@/components/dashboard/PositiveBanner";

    export default {
        components: {
          PositiveBanner,
          WMainTitle,
          ProviderOnBoarding,
          BasicProviderDashboard,
          SpecialistDashboard,
          AdministrativeDashboard
        },
        data() {
            return {
                breadcrumbs: [
                    {
                        text: 'Dashboard',
                        disabled: true,
                        href: ''
                    }
                ],
            }
        },

        computed: {
        ...mapState(['currentUser', 'currentProvider']),
          dashboardComponentName
      }
    }
</script>

<style scoped>
    a{
        text-decoration: none;
    }

    >>>.v-parallax__content{
        background-color: rgba(82, 82, 82, 0.89) !important
    }
</style>
